const  API_URL = process.env.REACT_APP_API_URL;
const  ASSETS_URL = process.env.REACT_APP_ASSETS_URL;
const  PUBLIC_INVOICE_ENABLED = process.env.REACT_APP_PUBLIC_INVOICE_ENABLED === 'true';

const config = {
    apiUrl: API_URL,
    assetsUrl:ASSETS_URL,
    publicInvoiceEnabled: PUBLIC_INVOICE_ENABLED,
}

export default config